<section class="dealer-transfer-summary">
  <!-- <app-form-container [dynamicFormArray]="filterSchema" [props]="props"></app-form-container>
  @if (validationMessage) {
    <div class="validation-message" role="alert">{{ validationMessage }}</div>
  } -->
  <app-dynamic-data-table [DataTableSchema]="tableSchema" [dataInput]="transferRows" [filterSchema]="filterSchema" [props]="props"></app-dynamic-data-table>
  <app-chart
    class="dealer-transfer-chart"
    [chartSchema]="chartSchema"
    [chartType]="'pie'"
    [elementId]="'dealer-transfer-bands'"
    [dataInput]="chartRows"
    [loading]="isLoading"
    [onLoadFetch]="false"
    [exportConfig]="tableSchema.exportConfig"
    [infoFields]="chartInfoFields">
  </app-chart>
</section>